import React from 'react';

interface DisconnectionOverlayProps {
  isDisconnected: boolean;
  reconnectAttempt?: number;
}

export const DisconnectionOverlay: React.FC<DisconnectionOverlayProps> = ({ isDisconnected, reconnectAttempt }) => {
  if (!isDisconnected) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        backgroundColor: '#1a1a2e',
        padding: '16px 20px',
        zIndex: 1000,
        fontFamily: '"Sometype Mono", monospace',
        minWidth: '300px',
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
        <div
          style={{
            width: '12px',
            height: '12px',
            backgroundColor: 'red',
            animation: 'pulse 1s infinite',
          }}
        />
        <div style={{ color: 'red', fontSize: '13px', fontWeight: 'bold', letterSpacing: '1px' }}>
          CONNECTION LOST
        </div>
      </div>

      {/* Status */}
      <div style={{ color: 'white', fontSize: '11px', marginBottom: '8px', lineHeight: '1.4' }}>
        Reconnecting to server...
      </div>

      {/* Info */}
      <div style={{ color: '#888888', fontSize: '9px', borderTop: '1px solid #333333', paddingTop: '8px' }}>
        Position will be restored
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
};
